import { render } from "./VisitanteSection.vue?vue&type=template&id=83f4e230&ts=true"
import script from "./VisitanteSection.vue?vue&type=script&lang=ts"
export * from "./VisitanteSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__